export default __webpack_public_path__ + "static/media/demand.4bf1397c.svg";